var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-container',[_c('b-card',{staticClass:"mt-3",staticStyle:{"margin-bottom":"100px"}},[_c('app-head'),_c('b-row',[_c('b-col',[_c('app-datenschutz')],1)],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }